import { CommonModule } from '@angular/common';
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { SelectedProfileService } from '../../services/selected-profile.service';
import { LayoutService } from './../../services/layout.service';

@Component({
  selector: 'app-header',
  imports: [MatIconModule, MatButtonModule, CommonModule, MatToolbarModule, MatSelectModule, MatFormFieldModule, MatMenuModule, MatDialogModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  authService = inject(AuthService);
  private selectedProfileService = inject(SelectedProfileService);
  private breadcrumbService = inject(BreadcrumbService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  isMobile = inject(LayoutService).isMobile;
  @ViewChild('pagovDialogTemplate') pagovDialogTemplate!: TemplateRef<any>;

  ngOnInit() {
    this.loadGoogleTranslate();
  }

  navigateToDashboard(event: MouseEvent) {
    event.preventDefault();
    this.selectedProfileService.clearSelectedProfile();
    this.breadcrumbService.refreshLabels();
    this.router.navigate(['/dashboard']);
  }

  loadGoogleTranslate() {
    const googleTranslateScript = document.createElement('script');
    googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    googleTranslateScript.async = true;
    googleTranslateScript.defer = true;
    document.head.appendChild(googleTranslateScript);
  }

  translate(lang: string) {
    const googleCombo = document.querySelector('.goog-te-combo') as HTMLSelectElement;

    if (googleCombo) {
      googleCombo.value = lang;
      googleCombo.dispatchEvent(new Event('change'));
    }
  }

  onLoginRegistartion(event: MatSelectChange) {
    const selectedValue = event.value;
    event.source.value = undefined;
    this.authService.login(selectedValue);
  }

  onLogout() {
    this.authService.logout();
  }

  openPagovDialog(event: Event) {
    event.preventDefault();
    this.dialog.open(this.pagovDialogTemplate, {
      width: '500px',
      height: '290px',
      autoFocus: false,
      panelClass: 'banner-dialog-panel',
      ariaLabelledBy: 'dialog-title',
      disableClose: true,
    });
  }
}
